import React from 'react';
import AvisoInstalacion from '../../layouts/BannerNoInstalacion';

const DescripcionPlafonFalso = () => {
  return (
    <section>
      <div className="container">
        <div className="row g-xxl-5 align-items-end mt-n1-9">
          <div className="col-lg-6 order-2 order-lg-1 mt-1-9">
            <div className="pe-lg-1-6 pe-xl-6">
              <img src={`${process.env.PUBLIC_URL}/assets/img/productos/techo-plafon-falso/plafon-falso-aplicacion.jpg`} alt="Plafón Falso de PVC" className="mb-6 mb-xl-10" />
              <div className="ps-lg-10 ps-xl-20">
                <div className="d-flex border-bottom pb-1-9 mb-1-9">
                  <div className="flex-shrink-0 me-4">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/icons/icon-60.png`} alt="icono" />
                  </div>
                  <div className="flex-grow-1">
                    <h4 className="h5">Medidas y composición</h4>
                    <p className="mb-0">
                    Ancho: 25 cm.<br></br>
                    Longitud: 5.95 metros<br></br>
                    Espesor: 7 cm.<br></br>
                    Peso: 4.300 kg..<br></br>
                    Material: PVC.<br></br>
                    Una pieza cubre: 1.4 m2.<br></br>
                    </p>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-shrink-0 me-4">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/icons/icon-68.png`} alt="icono" />
                  </div>
                  <div className="flex-grow-1">
                    <h4 className="h5">Por Qué Elegir el Plafón Falso de PVC </h4>
                    <p className="mb-0">
                    En Decototal entendemos que cada proyecto es único. Por eso, nuestros plafones falsos de PVC están diseñados para brindar calidad, estética y practicidad. Con ellos, garantizas resultados que cumplen con los estándares más exigentes del diseño contemporáneo.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2 mt-1-9">
            <div className="ps-lg-1-6 ps-xl-6">
              <div className="title-style1 mb-1-9 mb-lg-10 mb-xl-15">
                <span>Características</span>
                <h2 className="h1 mb-4">Aplicaciones Comunes</h2>
                <p className="mb-0">
                El plafón falso de PVC es una opción versátil y funcional que se adapta a diversos tipos de proyectos. 
                Es ideal para el revestimiento de techos, ofreciendo acabados limpios y modernos que son perfectos para oficinas, 
                locales comerciales y viviendas. También se utiliza en paredes decorativas, brindando un toque contemporáneo con acabados innovadores. 
                Gracias a su resistencia a la humedad, es una excelente opción para espacios como baños, cocinas y lavanderías, donde los materiales tradicionales suelen deteriorarse. Además, su durabilidad y bajo mantenimiento lo hacen especialmente adecuado para proyectos industriales, como naves industriales, hospitales y laboratorios, donde se requieren soluciones prácticas y de alta resistencia.
                </p>
              </div>
              <AvisoInstalacion className="mb-29" />
              <img src={`${process.env.PUBLIC_URL}/assets/img/productos/techo-plafon-falso/plafon-falso-aplicacion-2.jpg`} alt="Plafón Falso de PVC" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DescripcionPlafonFalso;